import { PlusOutlined } from '@ant-design/icons'
import { isSiDaMember } from '@util'
import { Divider, Select } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import CateForm from '../../../../Common/CateForm'

@observer
class Category extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false
    }
  }
  submitCasseCate = values => {
    this.setState({
      visible: false
    })
    this.props.store.submitCasseCate(values)
  }
  onChange = value => {
    this.props.onChange(value)
  }
  render() {
    const { store, value } = this.props
    const { case_cate } = store
    return (
      <Fragment>
        <Select
          placeholder="请选择"
          style={{ width: 200 }}
          // getPopupContainer={() => this.contentRef}
          value={value}
          onChange={this.onChange}
          dropdownRender={menu => (
            <div>
              {menu}
              <Divider style={{ margin: '4px 0' }} />
              {!isSiDaMember() && (
                <div
                  style={{ padding: '4px 8px', cursor: 'pointer' }}
                  onMouseDown={e => e.preventDefault()}
                  onClick={() => this.setState({ visible: true })}
                >
                  <PlusOutlined />新建分类
                </div>
              )}
            </div>
          )}
        >
          {case_cate.map((item, index) => {
            return (
              <Select.Option value={item.id} key={index}>
                {item.title}
              </Select.Option>
            )
          })}
        </Select>
        <CateForm
          visible={this.state.visible}
          onClose={() => this.setState({ visible: false })}
          onOk={this.submitCasseCate}
        />
      </Fragment>
    )
  }
}

export default observer(Category)
